var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"related_items"},[_c('Card',{staticClass:"recommend_pic",attrs:{"data":{'picture_url': _vm.recommend_picture_url,'html_url': _vm.recommend_html_url}}}),_c('RecentlyEvent'),_c('RecentlyLouPlus')],1)}
var staticRenderFns = []

export { render, staticRenderFns }